import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TextField, Button, Stack, Typography } from '@mui/material';
import { useAppContext } from '../context/AppContext';
import { useToast } from '../context/ToastContext';

const UserInitialize = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showCorrect, showError } = useToast();
  const { postInitializeUser, getBRI, bri } = useAppContext();
  const [user, setUser] = useState(null);
  const [username, setUsername] = useState('');

  const [form, setForm] = useState({
    email: '',
    password: '',
    passwordCheck: '',
  });

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const bri = await getBRI(id);
        console.log(bri);
      } catch (err) {
        showError('Error fetching user data');
      }
    };

    fetchUser();
  }, []);

  useEffect(() => {
    if (bri) {
      setUsername(bri.consumerNamesPath ? bri.consumerNamesPath[bri.consumerNamesPath.length - 1] : bri.username);
    }
  }, [bri]);

  const handleChange = (e) => {
    console.log(e.target.name, e.target.value);
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.password !== form.passwordCheck) {
      showError('Passwords do not match');
      return;
    }
    try {
      const response = await postInitializeUser(id, form.email, form.password);
      
      showCorrect('Password initialized successfully');
      navigate('/users');
    } catch (err) {
      showError('Error initializing password');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {bri ? (
        <Typography variant="h6">Initialize User: {username}</Typography>
      ) : (
        <Typography variant="h6">Loading...</Typography>
      )
      }
      <Stack spacing={2} direction="column" sx={{ my: 2 }}>
        <TextField
          // label="Email"
          placeholder="Email"
          name="email"
          // value={''}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          // label="Password"
          placeholder="Password"
          name="password"
          type="password"
          // value={form.password}
          // value=""
          onChange={handleChange}
          fullWidth
        />
        <TextField
          // label="Confirm Password"
          placeholder="Confirm Password"
          name="passwordCheck"
          type="password"
          // value={form.passwordCheck}
          onChange={handleChange}
          fullWidth
        />
        <Button variant="contained" type="submit" fullWidth>
          Initialize Password
        </Button>
      </Stack>
    </form>
  );
};

export default UserInitialize;